/* eslint-disable */
import { makeStyles } from "@material-ui/core/styles";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableFooter from "@material-ui/core/TableFooter";
import TableRow from "@material-ui/core/TableRow";
import Checkbox from "@saleor/components/Checkbox";
import ResponsiveTable from "@saleor/components/ResponsiveTable";
import Skeleton from "@saleor/components/Skeleton";
import TableCellHeader from "@saleor/components/TableCellHeader";
import TableHead from "@saleor/components/TableHead";
import TablePagination from "@saleor/components/TablePagination";
import {
  maybe,
  renderCollection
  // splitDateTime
} from "@saleor/misc";
import { ListActions, ListProps, SortPage } from "@saleor/types";
import React from "react";
import { FormattedMessage } from "react-intl";
import { WarehouseListUrlSortField } from "@saleor/warehouses/urls";

import { ProducttagsList_producttags_edges_node } from "../../types/ProducttagsList";

const useStyles = makeStyles(
  theme => ({
    [theme.breakpoints.up("lg")]: {
      colEnd: {
        width: 250
      },
      colName: {
        with: 300
      },
      colStart: {
        width: 250
      },
      colValue: {
        width: 200
      }
    },
    colEnd: {
      textAlign: "right"
    },
    colName: {
      paddingLeft: 0
    },
    colStart: {
      textAlign: "right"
    },
    colValue: {
      textAlign: "right"
    },
    tableRow: {
      cursor: "pointer"
    }
  }),
  { name: "SaleList" }
);

export interface SaleListProps
  extends ListProps,
    ListActions,
    SortPage<WarehouseListUrlSortField> {
  defaultCurrency: string;
  tags: ProducttagsList_producttags_edges_node[];
}

const numberOfColumns = 6;

const ProducttagsList: React.FC<SaleListProps> = props => {
  const {
    settings,
    // defaultCurrency,
    disabled,
    onNextPage,
    onPreviousPage,
    onUpdateListSettings,
    onRowClick,
    // onSort,
    pageInfo,
    tags,
    isChecked,
    selected,
    // sort,
    toggle,
    toggleAll,
    toolbar
  } = props;

  const classes = useStyles(props);

  return (
    <ResponsiveTable>
      <TableHead
        colSpan={numberOfColumns}
        selected={selected}
        disabled={disabled}
        items={tags}
        toggleAll={toggleAll}
        toolbar={toolbar}
      >
        <TableCellHeader
          // direction={
          //   sort.sort === SaleListUrlSortField.name
          //     ? getArrowDirection(sort.asc)
          //     : undefined
          // }
          // arrowPosition="right"
          // onClick={() => onSort(SaleListUrlSortField.name)}
          className={classes.colName}
        >
          <FormattedMessage
            defaultMessage="Producttag ID"
            description="producttag id"
          />
        </TableCellHeader>
        <TableCellHeader className={classes.colName}>
          <FormattedMessage
            defaultMessage="Title"
            description="producttag title"
          />
        </TableCellHeader>
        <TableCellHeader
          // direction={
          //   sort.sort === WarehouseListUrlSortField.name
          //     ? getArrowDirection(sort.asc)
          //     : undefined
          // }
          // arrowPosition="right"
          // onClick={() => onSort(WarehouseListUrlSortField.name)}
          className={classes.colName}
        >
          <FormattedMessage
            defaultMessage="Name"
            description="producttag name"
          />
        </TableCellHeader>
        <TableCellHeader className={classes.colName}>
          <FormattedMessage
            defaultMessage="Tag Type"
            description="producttag type"
          />
        </TableCellHeader>
        <TableCellHeader className={classes.colName}>
          <FormattedMessage
            defaultMessage="Text Component View"
            description="Text Component View"
          />
        </TableCellHeader>
        <TableCellHeader className={classes.colName}>
          <FormattedMessage
            defaultMessage="Text Product View"
            description="Text Product View"
          />
        </TableCellHeader>
      </TableHead>
      <TableFooter>
        <TableRow>
          <TablePagination
            colSpan={numberOfColumns}
            settings={settings}
            hasNextPage={pageInfo && !disabled ? pageInfo.hasNextPage : false}
            onNextPage={onNextPage}
            onUpdateListSettings={onUpdateListSettings}
            hasPreviousPage={
              pageInfo && !disabled ? pageInfo.hasPreviousPage : false
            }
            onPreviousPage={onPreviousPage}
          />
        </TableRow>
      </TableFooter>
      <TableBody>
        {renderCollection(
          tags,
          tag => {
            const isSelected = tag ? isChecked(tag.id) : false;

            return (
              <TableRow
                className={!!tag ? classes.tableRow : undefined}
                hover={!!tag}
                key={tag ? tag.id : "skeleton"}
                onClick={tag ? onRowClick(tag.id) : undefined}
                selected={isSelected}
              >
                <TableCell padding="checkbox">
                  <Checkbox
                    checked={isSelected}
                    disabled={disabled}
                    disableClickPropagation
                    onChange={() => toggle(tag.id)}
                  />
                </TableCell>
                <TableCell className={classes.colName}>
                  {maybe<React.ReactNode>(() => tag.tagId, <Skeleton />)}
                </TableCell>
                <TableCell className={classes.colName}>
                  {maybe<React.ReactNode>(() => tag.title, <Skeleton />)}
                </TableCell>
                <TableCell className={classes.colName}>
                  {maybe<React.ReactNode>(() => tag.name, <Skeleton />)}
                </TableCell>
                <TableCell className={classes.colName}>
                  {maybe<React.ReactNode>(() => tag.tagType, <Skeleton />)}
                </TableCell>
                <TableCell className={classes.colName}>
                  {maybe<React.ReactNode>(
                    () => (
                      <span style={{ color: tag.componentFontColor }}>
                        {tag.name}
                      </span>
                    ),
                    <Skeleton />
                  )}
                </TableCell>
                <TableCell className={classes.colName}>
                  {maybe<React.ReactNode>(
                    () => (
                      <span
                        style={{
                          color: tag.productFontColor,
                          background: tag.productBackgroundColor,
                          padding: "5px"
                        }}
                      >
                        {tag.name}
                      </span>
                    ),
                    <Skeleton />
                  )}
                </TableCell>
              </TableRow>
            );
          },
          () => (
            <TableRow>
              <TableCell colSpan={numberOfColumns}>
                <FormattedMessage defaultMessage="No tags found" />
              </TableCell>
            </TableRow>
          )
        )}
      </TableBody>
    </ResponsiveTable>
  );
};
ProducttagsList.displayName = "ProducttagsList";
export default ProducttagsList;
